import { createInteractiveColorVars } from '../../helpers/createInteractiveColorVars/index.js';

const AppleColors = createInteractiveColorVars('apple');
const AppleColorsLightValues = Object.freeze({
    base: {
        default: '#000000',
        action: '#1a1a1a',
        active: '#000000',
        activeAction: '#1a1a1a',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});
const AppleColorsDarkValues = Object.freeze({
    base: {
        default: '#ffffff',
        action: '#e6e6e6',
        active: '#ffffff',
        activeAction: '#e6e6e6',
    },
    text: {
        default: '#000000',
        action: '#000000',
        active: '#000000',
        activeAction: '#000000',
    },
});

export { AppleColors, AppleColorsDarkValues, AppleColorsLightValues };
